// ---------------------------------------------- modules import
import React, { FunctionComponent } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { IRowProps } from "./common";

// ---------------------------------------------- the component
const Row: FunctionComponent<IRowProps> = ({ user }) => {
  // ---------------------------------------------- router state
  let history = useHistory();
  let match = useRouteMatch();

  const { id, name, email } = user;

  // ---------------------------------------------- handlers
  const handleClick = () => {
    if (match) history.push(`${match.url}/${id}`);
  };

  // ---------------------------------------------- content
  return (
    <tr onClick={handleClick} style={{ cursor: "pointer" }}>
      <td>{name}</td>

      <td>{email}</td>
    </tr>
  );
};

export default Row;
